module.exports = __webpack_public_path__ + "img/project13_3.jpg.dea026a4.webp";